// extracted by mini-css-extract-plugin
module.exports = {"topWrap":"style_topWrap__1_Tuh"};